import React, { useState } from 'react';
import { __ } from 'i18n-for-browser';
import PropTypes from 'prop-types';
import JSZip from 'jszip';
import download from 'downloadjs';

import Loading from '../elements/Loading';

// Functional component to render the download audio button
function downloadAudioButton(props) {
  const [disabled, setDisabled] = useState(false);

  /**
   * Download zip containing all audio files.
   * @param {Array<String>} audio
   * @returns {Promise<void>}
   */
  async function downloadAudio(audio = []) {
    return null;
    if (!disabled) {
      setDisabled(true);
    } else {
      return;
    }
    const zip = new JSZip();
    const files = await Promise.all(audio.map((a) => {
      return fetch(a)
        .then(r => r.blob())
        .catch(console.error);
    }));
    files.forEach((file, i) => {
      const splitVal = decodeURIComponent(audio[i]).split('/');
      const fileName = splitVal[splitVal.length - 1];
      zip.file(fileName, file);
    });

    await zip.generateAsync({ type: 'blob' })
      .then(blob => download(blob, `ER-audio-${Date.now().toString()}.zip`))
      .catch(console.error);
    setDisabled(false);
  }

  if (!props.audio.length) return null;
  return (
    <button onClick={() => { downloadAudio(props.audio); }} style={{ opacity: disabled ? '0.5' : '1', display: 'none' }}>
      {disabled ? <Loading /> : null}
      <span>{__('sim_download_audio_button')}</span>
    </button>
  );
}

downloadAudioButton.propTypes = {
  audio: PropTypes.arrayOf(PropTypes.string),
};

downloadAudioButton.defaultProps = {
  audio: [],
};

export default downloadAudioButton;



// WEBPACK FOOTER //
// ./src/components/elements/DownloadAudioButton.js